import UserService from 'Services/user';
import HostedFields from 'Components/hosted-fields';
import Paypal from 'Components/paypal';

export default {
	name: 'account-payment-modal',
	components: {
		HostedFields,
		Paypal
	},
	created() {
		this.vue = this;
		this.isGettingClientToken = true;
		this.isGettingTotalPrice = true;
		UserService.getClientToken()
			.then(response => {
				this.token = response.data.token;
			})
			.catch(error => {
				this.errors.add({
					field: 'apierror',
					msg: error.response.data.Message
				});
			})
			.finally(() => {
				this.isGettingClientToken = false;
			});
		UserService.getTotalPrice()
			.then(response => {
				this.plan.priceTotal = response.data.price_total;
			})
			.catch(error => {
				this.errors.add({
					field: 'apierror',
					msg: error.response.data.Message
				});
			})
			.finally(() => {
				this.isGettingTotalPrice = false;
			});
	},
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
	},
	data() {
		return {
			vue: undefined,
			isGettingClientToken: false,
			isGettingTotalPrice: false,
			backed: false,
			isSaving: false,
			isHFReady: false,
			tabs: 'card',
			token: '',
			plan: {
				priceTotal: undefined
			}
		};
	},
	computed: {
		isLoading() {
			return this.isGettingClientToken || this.isGettingTotalPrice;
		}
	},
	methods: {
		updatePaymentMethod() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.isSaving = true;
					this.$emit('tokenize');
				}
			});
		},
		btHFError(message) {
			this.isSaving = false;
			if (message !== undefined) {
				this.errors.add({
					field: 'apierror',
					msg: 'Invalid credit card'
				});
			}
		},
		btPaypalError(message) {
			if (message !== undefined) {
				this.errors.add({
					field: 'apierror',
					msg: 'Paypal error'
				});
			}
		},
		btHFPayload(payload) {
			this.btPayload(payload);
		},
		btPaypalPayload(payload) {
			this.btPayload(payload);
		},
		btPayload(payload) {
			UserService.setPaymentMethod(this.tabs, payload.nonce)
				.then(response => {
					this.isSaving = false;
					this.back();
					if (this.tabs === 'card') {
						this.$parent.paymentMethodUpdated('**** **** **** ' + payload.details.lastFour);
					} else {
						this.$parent.paymentMethodUpdated('Paypal (' + payload.details.email + ')');
					}
				})
				.catch(error => {
					this.isSaving = false;
					this.errors.add({
						field: 'apierror',
						msg: 'Unable to update payment method'
					});
				});
		},
		back() {
			if (!this.backed) {
				this.backed = true;
				this.$router.push('/account');
			}
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/account-payment-modal/script.js